import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { BaseDialog } from "src/app/base-dialog";

@Component({
  selector: "mandae-relatorio-excluir",
  templateUrl: "./excluir-relatorio.component.html",
  styleUrls: ["./excluir-relatorio.component.scss"]
})
export class ModalExcluirComponent extends BaseDialog<ModalExcluirComponent> {
  constructor(dialogRef: MatDialogRef<ModalExcluirComponent>) {
    super(dialogRef);
  }

  confirmar() {
    this.dialogRef.close(true);
  }

  fechar() {
    this.dialogRef.close(false);
  }
}
